import { render } from "./DownloadList.vue?vue&type=template&id=0ecae5e1"
import script from "./DownloadList.vue?vue&type=script&lang=js"
export * from "./DownloadList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__